// @flow

import React, { Fragment } from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin, mediaMax } from 'frontend_core/dist/styles/media'
import { spacing, zIndexes } from 'frontend_core/dist/styles/variables'
import {
  reservationSidebarWidth,
  reservationSidebarWidthTb,
} from 'components/templates/MainContentsWithSidebarInbox'

const ContainerHeight = 74
const ContainerHeightSp = 44
const SpacingToSidebarPc = reservationSidebarWidth + spacing.huge
const SpacingToSidebarTb = reservationSidebarWidthTb + spacing.medium_3

const Base = styled.div`
  ${mediaMin.phone`
    height: ${ContainerHeight}px;
  `};
`
const Container = styled.div`
  left: 0;
  width: 100%;
  max-width: none;
  height: ${ContainerHeightSp}px;
  margin-top: ${spacing.large}px;
  ${({ textAlignSp }) =>
    textAlignSp &&
    css`
      text-align: ${textAlignSp};
    `}
  ${mediaMin.phone`
    position: fixed;
    bottom: 0;
    height: ${ContainerHeight}px;
    background-color: ${Colors.white};
    z-index: ${zIndexes.baloon};
    margin-top: 0;
  `}
  ${({ hasSidebar }) => {
    if (hasSidebar) {
      return css`
        ${mediaMin.phone`
          width: calc(100% - ${SpacingToSidebarTb}px);
          max-width: 600px;
          left: ${SpacingToSidebarTb}px;
        `} ${mediaMin.desktop`
          width: calc(100% - ${SpacingToSidebarPc}px);
          left: ${SpacingToSidebarPc}px;
        `};
      `
    } else {
      return css`
        ${mediaMin.phone`
          width: 100%;
          max-width: 768px;
        `};
      `
    }
  }}
  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `}
`

const Content = styled.div`
  ${mediaMin.phone`
    padding: ${spacing.medium}px 0;
  `};
`

const Line = styled.div`
  margin: 0 ${spacing.small_3}px;
  ${mediaMin.phone`
    margin: 0;
    border-top: 1px solid ${Colors.grayD};
  `};
`

export type PropTypes = {
  textAlign: string,
  textAlignSp?: string,
  hasSidebar?: boolean,
  inbox?: boolean,
  children: any,
}

export default (props: PropTypes) => (
  <Fragment>
    <Container
      textAlign={props.textAlign}
      textAlignSp={props.textAlignSp}
      hasSidebar={props.hasSidebar}
      inbox={props.inbox}
    >
      <Line />
      <Content>{props.children}</Content>
    </Container>
    <Base />
  </Fragment>
)



// WEBPACK FOOTER //
// ./src/components/molecules/FloatBottom/index.jsx